import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  IconButton,
  InputAdornment,
  Card,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import { BsEye } from "react-icons/bs";
import { BsEyeSlash } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import bg from '../../src/assets/Images/loginbg.jpg'
import bg1 from '../../src/assets/Images/loginbg1.png'
import logo from "../assets/Images/leopharma.png"
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import axios from "axios";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();


  const handleLogin = async (event) => {
    event.preventDefault();
  
    try {
      const response = await axios.post("login/", {
        username,
        password,
      }, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.data;
  
      if (data.status === "success") {
        console.log("Login successful:", data);

        
        
        const mockToken = Math.random().toString(36).substr(2);; 
  
       
        localStorage.setItem('token', mockToken);
        
        localStorage.setItem('username', data.username);
  
        navigate("/");
      } else {
        setError(data.message || "Login failed");
      }
    } catch (err) {
      if(err?.response?.status === 400){
        setError(err?.response?.data?.message)
        // setError("Invalid Credentials")
      }
      else{
        setError("Something went wrong. Please try again.");
      }
    }
  };
  

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "username") setUsername(value.trim());
    if (name === "password") setPassword(value.trim());
    if (name === "remember") setRemember(checked);
    if (error) setError("");
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Box
      
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#daedfe",
        padding: { xs: 2, sm: 4 }, 
      }}
    >
      <Grid
        container
        sx={{
          width: { xs: "100%", sm: "90%", md: "80%" }, 
          maxWidth: { xs: "400px", md: "800px" }, 

          borderRadius: "12px",
          overflow: "hidden",
          bgcolor: "#fff",
          margin: "auto", 
        }}
        spacing={3}
      >
     
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding: { xs: 2, sm: 3, md: 4 },
          }}
        >
          <form onSubmit={handleLogin} style={{ padding: "10px 24px 24px 24px" }}>
           
            
            <div style={{display:"flex",justifyContent:"center",marginBottom:"15px"}}>
            <img src={logo} alt="logo" height={50} width={200} />
            </div>
            <div style={{display:"flex",justifyContent:"center"}}>
            <Typography
              variant="p"
              
               color="grey"
              gutterBottom
              sx={{
                marginLeft:"10px",
                fontWeight: "400",
                fontSize: { xs: "1rem", md: "1rem" }, 
              }}
            >
              Enter Your Login Credentials
            </Typography>
            </div>
           {/* <div  style={{display:"flex",justifyContent:"center",marginTop:"20px"}}>
           <Typography
              variant="body1"
              align="left"
              color="textSecondary"
              gutterBottom
              sx={{ fontSize: { xs: "0.6rem", md: "0.9rem" } }}
            >
              Login to the Dashboard
            </Typography>
           </div> */}
            

           
            <TextField
              label="Username"
              variant="outlined"
              fullWidth
              size="small"
              margin="normal"
              name="username"
              value={username}
              onChange={handleInputChange}
              required
              placeholder="Username"
              sx={{ borderRadius: "8px" }}
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              label="Password"
              variant="outlined"
              fullWidth
              size="small"
              margin="normal"
              type={showPassword ? "text" : "password"}
              name="password"
              value={password}
              onChange={handleInputChange}
              required
              placeholder="Password"
              sx={{ borderRadius: "8px" }}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={togglePasswordVisibility} edge="end" sx={{fontSize:'16px'}}>
                      {showPassword ? <BsEyeSlash /> : <BsEye/>}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
              {error && (
              <Typography
                variant="body2"
                color="error"
                // align="center"
               
              >
                {error}
              </Typography>
            )}
            <FormControlLabel
              control={
                <Checkbox
                  checked={remember}
                  onChange={handleInputChange}
                  name="remember"
                  sx={{ color: "#1976D2" }}
                />
              }
              label="Remember me"
              sx={{ mt: 1 }}
            />
        

            <Button
              type="submit"
              variant="contained"
              size="small"
              fullWidth
              sx={{
                mt: 2,
                bgcolor: "#1976D2",
                color: "#fff",
                padding: { xs: "4px", md: "6px" }, 
                fontSize: { xs: "14px", md: "16px" },
                textTransform: "none",
              }}
              disableElevation
            >
              LOGIN
            </Button>
          </form>
        </Grid>

        {/* Right Side - Illustration */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: { xs: "none", md: "flex" }, 
            justifyContent: "center",
            alignItems: "center",
            bgcolor: "#1976D280",
            padding: "16px",
            backgroundImage: `url(${bg1})`,
            backgroundSize: "cover", 
            backgroundPosition: "center", 
            backgroundRepeat: "no-repeat", 
          }}
        >
          
        </Grid>
      </Grid>
    </Box>
  );
};

export default Login;
